import React, { Component } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label
} from 'reactstrap';

import LoginService from '../../services/LoginService';
import CONSTANTS from '../../constants';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: '',
      password: ''
    }
  }

  componentDidMount() {
    if(this.props.location.state && this.props.location.state.from) localStorage.setItem('returnURL', this.props.location.state.from);
    if(this.props.location.state && this.props.location.state.data) localStorage.setItem('returnData', JSON.stringify(this.props.location.state.data));
    if(LoginService.getToken()) this.redirectToReturnURL();
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  login() {
    this.setState({ loading: true }, async () => {
      try {
        let tokenData = await LoginService.login(this.state.email, this.state.password);
        LoginService.setLoginData(tokenData);
        this.redirectToReturnURL();
      } catch (e) {
        this.setState({ loading: false });
        alert('Failed login attempt. Please enter correct username or password.');
      }
    });
  }

  returnURL() {
    let url = localStorage.getItem('returnURL') || `${CONSTANTS.BASE_URL}`;
    localStorage.removeItem('returnURL');
    return url;
  }

  returnData() {
    let data = localStorage.getItem('returnData') || null;
    localStorage.removeItem('returnData');
    if(data) return JSON.parse(data);
  }

  redirectToReturnURL() {
    this.props.history.push(this.returnURL(), this.returnData());
  }

  render() {
    return (
      <Row className='m-0 justify-content-center'>
        <Col
          sm='8'
          xl='7'
          lg='10'
          md='8'
          className='d-flex justify-content-center'
        >
          <Card className='bg-authentication login-card rounded-0 mb-0 w-100'>
            <Row className='m-0'>
              <Col lg='12' md='12' className='p-0'>
                <Card className='rounded-0 mb-0 px-2'>
                  <CardBody>
                    <h4>Sunbelt Planogram Panel</h4>
                    <p>Create and share planograms</p>
                    <Form onSubmit={e => e.preventDefault()}>
                      <FormGroup className='form-label-group position-relative has-icon-left'>
                        <Input
                          type='email'
                          placeholder='Email'
                          name='email'
                          value={this.state.email}
                          onChange={this.handleInputChange.bind(this)}
                        />
                        <Label>Email</Label>
                      </FormGroup>
                      <FormGroup className='form-label-group position-relative has-icon-left'>
                        <Input
                          type='password'
                          name='password'
                          placeholder='Password'
                          value={this.state.password}
                          onChange={this.handleInputChange.bind(this)}
                        />
                        <Label>Password</Label>
                      </FormGroup>
                      <div className='d-flex justify-content-between'>
                        <Button color='primary' type='submit' onClick={this.login.bind(this)}>
                          {this.state.loading && this.renderLoader()}
                          {!this.state.loading && 'Login'}
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }

  renderLoader() {
    return (
      <div className='text-sm spinner-border text-primary' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
    );
  }
}

export default Login;
